import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { forgotPasswordAPI } from "../APIs/API";
import { MyContext } from "../MyContext/MyProvider";

const Forgetpassword = () => {
  const navigate = useNavigate();
  const { setIsLoading } = useContext(MyContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const res = await forgotPasswordAPI(data);
      res && navigate("/verifyCode");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="login-main-container h-center v-center">
        <div className="login-container w-100 ">
          <div className="input-form-main ">
            <h3 className="text-medium-black ">Forgot Password</h3>
            <form
              className="input-form h-center flex-column forgetpswd"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="mt-50 h-center flex-column gap-12 pt-2">
                <label className="large fw-normal text-medium-black">
                  Enter Your Email address
                </label>
                <input
                  {...register("email", {
                    required: "Email is required",
                    maxLength: {
                      value: 30,
                      message: "Must not be more than 30 characters",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
                      message: "Invalid email address",
                    },
                  })}
                  inputMode="email"
                  type="email"
                  className="form-input"
                  placeholder="abc@gmail.com"
                />
                {errors.email && (
                  <span className="error">{errors.email.message}</span>
                )}
                {/* <label className="large fw-normal text-medium-black">
                  Select your role
                </label>
                <select
                  {...register("role", {
                    required: "Role is required",
                  })}
                  className="form-input"
                >
                  <option value="">Select your role</option>{" "}
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                </select>
                {errors.role && (
                  <span className="error">{errors.role.message}</span>
                )} */}
              </div>
              <div className="bottom-btn-div mt-5 pt-1">
                <button className="btn-primary" type="submit">
                  Next
                </button>
                <div className="mt-3">
                  <label className="small fw-normal h-center v-center gap-1 text-black">
                    Already have an account?
                    <Link to="/login">
                      <label className=" text-red link">Login</label>
                    </Link>
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgetpassword;
